import { DotLegalLink } from "@dotlegal/dotlegal-ui-components";
import { useUserContext } from "../../auth/userContextProvider/UserContextProvider";
import { useUrlProvider } from "../../useUrlProvider";
import React from "react";
import { isNullOrWhitespace } from "@common/stringOperations";

export interface IProcessingActivityLinksProps {
    processingActivityLinks: Array<{ id: string; name: string }>;
    tab?: string;
    onClick?: () => void;
}

function ProcessingActivityLinks(props: IProcessingActivityLinksProps) {
    const urlProvider = useUrlProvider();
    const { permissions } = useUserContext();

    if (permissions.processingActivityPermissions.read) {
        return props.processingActivityLinks.map((x, i) => (
            <React.Fragment key={x.id}>
                <DotLegalLink
                    linkColor={"primary"}
                    bold
                    stopPropagation
                    to={`${urlProvider.getProcessingActivityOverviewUrl(x.id)}${!isNullOrWhitespace(props.tab) ? "?tab=" + props.tab : ""}`}
                >
                    {x.name}
                </DotLegalLink>
                {i !== props.processingActivityLinks.length - 1 && <span style={{ marginRight: "4px" }}>,</span>}
            </React.Fragment>
        ));
    }

    return props.processingActivityLinks.flatMap((system) => system.name).join(", ");
}

export default ProcessingActivityLinks;
